var v = "5.7.11";
var fr = 29.9700012207031;
var ip = 0;
var op = 121.000004928431;
var w = 469;
var h = 469;
var nm = "PaperPlane  nofade";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Plane",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                -127.025
                            ],
                            [
                                127.026,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.025,
                                0
                            ]
                        ],
                        o: [
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ],
                            [
                                127.026,
                                0
                            ]
                        ],
                        v: [
                            [
                                230.5,
                                0.5
                            ],
                            [
                                0.5,
                                230.5
                            ],
                            [
                                -229.5,
                                0.5
                            ],
                            [
                                0.5,
                                -229.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('Fill').content('Group 1').content('Path 1').path;"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ty: "gr",
                        it: [
                            {
                                ind: 0,
                                ty: "sh",
                                ix: 1,
                                ks: {
                                    a: 1,
                                    k: [
                                        {
                                            i: {
                                                x: 0.16,
                                                y: 1
                                            },
                                            o: {
                                                x: 0.84,
                                                y: 0
                                            },
                                            t: 17,
                                            s: [
                                                {
                                                    i: [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    o: [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    v: [
                                                        [
                                                            -123.406,
                                                            118.038
                                                        ],
                                                        [
                                                            -179.052,
                                                            98.562
                                                        ],
                                                        [
                                                            93.052,
                                                            -84.421
                                                        ],
                                                        [
                                                            -14.899,
                                                            183.421
                                                        ],
                                                        [
                                                            -73.326,
                                                            141.687
                                                        ],
                                                        [
                                                            -118.824,
                                                            182.744
                                                        ]
                                                    ],
                                                    c: true
                                                }
                                            ]
                                        },
                                        {
                                            t: 25,
                                            s: [
                                                {
                                                    i: [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    o: [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    v: [
                                                        [
                                                            -37.406,
                                                            19.038
                                                        ],
                                                        [
                                                            -93.052,
                                                            -0.438
                                                        ],
                                                        [
                                                            93.052,
                                                            -84.421
                                                        ],
                                                        [
                                                            71.101,
                                                            84.421
                                                        ],
                                                        [
                                                            12.674,
                                                            42.687
                                                        ],
                                                        [
                                                            -32.824,
                                                            83.744
                                                        ]
                                                    ],
                                                    c: true
                                                }
                                            ],
                                            h: 1
                                        },
                                        {
                                            t: 90.0000036657751,
                                            s: [
                                                {
                                                    i: [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    o: [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    v: [
                                                        [
                                                            -37.406,
                                                            19.038
                                                        ],
                                                        [
                                                            -93.052,
                                                            -0.438
                                                        ],
                                                        [
                                                            93.052,
                                                            -84.421
                                                        ],
                                                        [
                                                            71.101,
                                                            84.421
                                                        ],
                                                        [
                                                            12.674,
                                                            42.687
                                                        ],
                                                        [
                                                            -32.824,
                                                            83.744
                                                        ]
                                                    ],
                                                    c: true
                                                }
                                            ],
                                            h: 1
                                        }
                                    ],
                                    ix: 2
                                },
                                nm: "Path 1",
                                mn: "ADBE Vector Shape - Group",
                                hd: false
                            },
                            {
                                ty: "st",
                                c: {
                                    a: 0,
                                    k: [
                                        0.298039227724,
                                        0.607843160629,
                                        0.831372559071,
                                        1
                                    ],
                                    ix: 3,
                                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 4
                                },
                                w: {
                                    a: 0,
                                    k: 19.167,
                                    ix: 5
                                },
                                lc: 1,
                                lj: 2,
                                bm: 0,
                                nm: "Stroke 1",
                                mn: "ADBE Vector Graphic - Stroke",
                                hd: false
                            },
                            {
                                ty: "tr",
                                p: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 2
                                },
                                a: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 1
                                },
                                s: {
                                    a: 0,
                                    k: [
                                        100,
                                        100
                                    ],
                                    ix: 3
                                },
                                r: {
                                    a: 0,
                                    k: 0,
                                    ix: 6
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 7
                                },
                                sk: {
                                    a: 0,
                                    k: 0,
                                    ix: 4
                                },
                                sa: {
                                    a: 0,
                                    k: 0,
                                    ix: 5
                                },
                                nm: "Transform"
                            }
                        ],
                        nm: "Group 1",
                        np: 2,
                        cix: 2,
                        bm: 0,
                        ix: 1,
                        mn: "ADBE Vector Group",
                        hd: false
                    },
                    {
                        ty: "gr",
                        it: [
                            {
                                ind: 0,
                                ty: "sh",
                                ix: 1,
                                ks: {
                                    a: 1,
                                    k: [
                                        {
                                            i: {
                                                x: 0.16,
                                                y: 1
                                            },
                                            o: {
                                                x: 0.84,
                                                y: 0
                                            },
                                            t: 17,
                                            s: [
                                                {
                                                    i: [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    o: [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    v: [
                                                        [
                                                            49.64,
                                                            -78.113
                                                        ],
                                                        [
                                                            -135.64,
                                                            122.703
                                                        ],
                                                        [
                                                            -52.594,
                                                            175.113
                                                        ]
                                                    ],
                                                    c: false
                                                }
                                            ]
                                        },
                                        {
                                            t: 25,
                                            s: [
                                                {
                                                    i: [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    o: [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    v: [
                                                        [
                                                            49.64,
                                                            -78.113
                                                        ],
                                                        [
                                                            -49.64,
                                                            23.703
                                                        ],
                                                        [
                                                            33.406,
                                                            76.113
                                                        ]
                                                    ],
                                                    c: false
                                                }
                                            ],
                                            h: 1
                                        },
                                        {
                                            t: 90.0000036657751,
                                            s: [
                                                {
                                                    i: [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    o: [
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ],
                                                        [
                                                            0,
                                                            0
                                                        ]
                                                    ],
                                                    v: [
                                                        [
                                                            49.64,
                                                            -78.113
                                                        ],
                                                        [
                                                            -49.64,
                                                            23.703
                                                        ],
                                                        [
                                                            33.406,
                                                            76.113
                                                        ]
                                                    ],
                                                    c: false
                                                }
                                            ],
                                            h: 1
                                        }
                                    ],
                                    ix: 2
                                },
                                nm: "Path 1",
                                mn: "ADBE Vector Shape - Group",
                                hd: false
                            },
                            {
                                ty: "st",
                                c: {
                                    a: 0,
                                    k: [
                                        0.298039227724,
                                        0.607843160629,
                                        0.831372559071,
                                        1
                                    ],
                                    ix: 3,
                                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 4
                                },
                                w: {
                                    a: 0,
                                    k: 19.167,
                                    ix: 5
                                },
                                lc: 1,
                                lj: 2,
                                bm: 0,
                                nm: "Stroke 1",
                                mn: "ADBE Vector Graphic - Stroke",
                                hd: false
                            },
                            {
                                ty: "tr",
                                p: {
                                    a: 0,
                                    k: [
                                        35,
                                        1
                                    ],
                                    ix: 2
                                },
                                a: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 1
                                },
                                s: {
                                    a: 0,
                                    k: [
                                        100,
                                        100
                                    ],
                                    ix: 3
                                },
                                r: {
                                    a: 0,
                                    k: 0,
                                    ix: 6
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 7
                                },
                                sk: {
                                    a: 0,
                                    k: 0,
                                    ix: 4
                                },
                                sa: {
                                    a: 0,
                                    k: 0,
                                    ix: 5
                                },
                                nm: "Transform"
                            }
                        ],
                        nm: "Group 2",
                        np: 2,
                        cix: 2,
                        bm: 0,
                        ix: 2,
                        mn: "ADBE Vector Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.833,
                                        y: 0.97
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 12,
                                    s: [
                                        -270.309,
                                        264.355
                                    ],
                                    to: [
                                        36.465,
                                        -35.662
                                    ],
                                    ti: [
                                        -70.217,
                                        68.671
                                    ]
                                },
                                {
                                    i: {
                                        x: 0.833,
                                        y: 0.856
                                    },
                                    o: {
                                        x: 0.167,
                                        y: 0.985
                                    },
                                    t: 24,
                                    s: [
                                        -38.616,
                                        37.766
                                    ],
                                    to: [
                                        16.534,
                                        -16.17
                                    ],
                                    ti: [
                                        -8.586,
                                        8.397
                                    ]
                                },
                                {
                                    t: 89.0000036250443,
                                    s: [
                                        0,
                                        0
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Fill",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 14.0000005702317,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        127.026,
                                        0
                                    ],
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        -127.025,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        -127.025,
                                        0
                                    ],
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        127.026,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        230,
                                        0
                                    ],
                                    [
                                        0,
                                        230
                                    ],
                                    [
                                        -230,
                                        0
                                    ],
                                    [
                                        0,
                                        -230
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.949019610882,
                                0.972549021244,
                                0.992156863213,
                                1
                            ],
                            ix: 4
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var PaperPlane = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, PaperPlane as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=PaperPlane.json.es.js.map
